import React, { useState } from 'react';
import styles from './TextWithHiding.module.scss';

const TextWithHiding = ({ text, textLength = 200 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleShowMore = () => {
    setIsExpanded(true);
  };

  const handleShowLess = () => {
    setIsExpanded(false);
  };

  return (
    <div className={styles.textDisplay}>
      <div className={`${styles.text} ${isExpanded ? styles.expanded : ''}`}>
        {!isExpanded ? `${text.slice(0, textLength)}...` : text}
      </div>

      {text.length > textLength && (
        <div className={styles.actions}>
          {isExpanded ? (
            <div className={styles.showLessBtn} onClick={handleShowLess}>
              Show Less
            </div>
          ) : (
            <div className={styles.showMoreBtn} onClick={handleShowMore}>
              Show More
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TextWithHiding;
